import React from 'react';
import PropTypes from 'prop-types';

import ProductNavigationItem, {
  ProductNavigationTargetOptions,
} from './ProductNavigationItem';

const ProductNavigation = ({ heading, navigationItemTargets }) => {
  const navigationItems = navigationItemTargets.map(target => {
    return <ProductNavigationItem key={target} target={target} />;
  });

  return (
    <div className="product-navigation">
      {!!heading && (
        <div className="content-wrapper">
          <h1 className="subheading--small">{heading}</h1>
        </div>
      )}

      <div className="content-wrapper product-navigation__items-wrapper">
        <div className="product-navigation__items-inner">
          <div className="product-navigation__items">{navigationItems}</div>
        </div>
      </div>
    </div>
  );
};

ProductNavigation.propTypes = {
  heading: PropTypes.string,
  navigationItemTargets: PropTypes.arrayOf(ProductNavigationTargetOptions)
    .isRequired,
};

export default ProductNavigation;
